import script from "./PsychogramManager.vue?vue&type=script&setup=true&lang=js"
export * from "./PsychogramManager.vue?vue&type=script&setup=true&lang=js"

import "./PsychogramManager.vue?vue&type=style&index=0&id=2f7f7293&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f7f7293"]])

export default __exports__